"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _index = require("@/lang/index");
var _config = require("@/api/common/config");
var _utils = require("@/utils");
var state = {
  sidebar: {
    opened: _jsCookie.default.get('sidebarStatus') ? !!+_jsCookie.default.get('sidebarStatus') : true,
    isShow: true,
    withoutAnimation: false
  },
  device: 'desktop',
  language: (0, _index.getLanguage)(),
  size: _jsCookie.default.get('size') || 'mini',
  deploy: (0, _utils.getDeploy)(),
  version: '',
  tagBgColor: {},
  commonQueryParams: {} //公共查询条件
};
var mutations = {
  TOGGLE_SIDEBAR: function TOGGLE_SIDEBAR(state) {
    state.sidebar.opened = !state.sidebar.opened;
    state.sidebar.withoutAnimation = false;
    if (state.sidebar.opened) {
      _jsCookie.default.set('sidebarStatus', 1);
    } else {
      _jsCookie.default.set('sidebarStatus', 0);
    }
  },
  SHOW_SIDEBAR: function SHOW_SIDEBAR(state, status) {
    state.sidebar.isShow = status;
  },
  CLOSE_SIDEBAR: function CLOSE_SIDEBAR(state, withoutAnimation) {
    _jsCookie.default.set('sidebarStatus', 0);
    state.sidebar.opened = false;
    state.sidebar.withoutAnimation = withoutAnimation;
  },
  TOGGLE_DEVICE: function TOGGLE_DEVICE(state, device) {
    state.device = device;
  },
  SET_LANGUAGE: function SET_LANGUAGE(state, language) {
    state.language = language;
    _jsCookie.default.set('locale', language === 'zh' ? 'zh-CN' : 'en-US', {
      expires: 7
    });
  },
  SET_SIZE: function SET_SIZE(state, size) {
    state.size = size;
    _jsCookie.default.set('size', size);
  },
  GET_DEPLOY_LOCATION: function GET_DEPLOY_LOCATION(state, _ref) {
    var location = _ref.location,
      displayValue = _ref.displayValue;
    state.deploy = location;
    state.version = displayValue;
  },
  SET_TAG_COLOR: function SET_TAG_COLOR(state, colorObj) {
    state.tagBgColor = colorObj;
  },
  INPUT_CHINESE_COMPANY_CONFIG: function INPUT_CHINESE_COMPANY_CONFIG(state, data) {
    state.inputChineseCompanyConfig = data;
  },
  INVALID_INPUT_CHINESE_MENU_CONFIG: function INVALID_INPUT_CHINESE_MENU_CONFIG(state, data) {
    state.invalidInputChineseMenuConfig = data;
  },
  SET_COMMON_QUERY_PARAMS: function SET_COMMON_QUERY_PARAMS(state, data) {
    state.commonQueryParams = data;
  }
};
var actions = {
  toggleSideBar: function toggleSideBar(_ref2) {
    var commit = _ref2.commit;
    commit('TOGGLE_SIDEBAR');
  },
  isShowSideBar: function isShowSideBar(_ref3, status) {
    var commit = _ref3.commit;
    commit('SHOW_SIDEBAR', status);
  },
  closeSideBar: function closeSideBar(_ref4, _ref5) {
    var commit = _ref4.commit;
    var withoutAnimation = _ref5.withoutAnimation;
    commit('CLOSE_SIDEBAR', withoutAnimation);
  },
  toggleDevice: function toggleDevice(_ref6, device) {
    var commit = _ref6.commit;
    commit('TOGGLE_DEVICE', device);
  },
  setLanguage: function setLanguage(_ref7, language) {
    var commit = _ref7.commit;
    commit('SET_LANGUAGE', language);
  },
  setSize: function setSize(_ref8, size) {
    var commit = _ref8.commit;
    commit('SET_SIZE', size);
  },
  getDeploy: function getDeploy(_ref9) {
    var commit = _ref9.commit;
    return new Promise(function (resolve, reject) {
      (0, _config.getDeployLocation)().then(function (res) {
        if (res.success) {
          commit('GET_DEPLOY_LOCATION', res.data);
        }
        resolve();
      }).catch(function () {
        reject();
      });
    });
  },
  getStatusColor: function getStatusColor(_ref10) {
    var commit = _ref10.commit;
    return new Promise(function (resolve) {
      (0, _config.getDictCode)({
        codeTypes: 'STATUS_COLOR_CONFIG'
      }).then(function (res) {
        if (!res.data.STATUS_COLOR_CONFIG) return resolve({});
        var colorObj = res.data.STATUS_COLOR_CONFIG.reduce(function (obj, v) {
          obj[v.codeValue] = v.displayValue;
          return obj;
        }, {});
        commit('SET_TAG_COLOR', colorObj);
        resolve(colorObj);
      });
    });
  },
  getInputChineseCompanyConfig: function getInputChineseCompanyConfig(_ref11) {
    var commit = _ref11.commit;
    return new Promise(function (resolve) {
      (0, _config.getDictCode)({
        codeTypes: 'INPUT_CHINESE_COMPANY_CONFIG,INVALID_INPUT_CHINESE_MENU_CONFIG'
      }).then(function (res) {
        var retMap = {};
        if (res.data.INPUT_CHINESE_COMPANY_CONFIG) {
          retMap = res.data.INPUT_CHINESE_COMPANY_CONFIG.reduce(function (obj, v) {
            obj[v.codeValue] = v.displayValue === '1';
            return obj;
          }, {});
        }
        commit('INPUT_CHINESE_COMPANY_CONFIG', retMap);
        if (res.data.INVALID_INPUT_CHINESE_MENU_CONFIG) {
          var retInvalidMap = res.data.INVALID_INPUT_CHINESE_MENU_CONFIG.reduce(function (obj, v) {
            obj[v.displayValue] = v.codeValue === '0';
            return obj;
          }, {});
          commit('INVALID_INPUT_CHINESE_MENU_CONFIG', retInvalidMap);
        } else {
          commit('INVALID_INPUT_CHINESE_MENU_CONFIG', {});
        }
        resolve(retMap);
      });
    });
  },
  setCommonQueryParams: function setCommonQueryParams(_ref12, queryParams) {
    var commit = _ref12.commit;
    commit('SET_COMMON_QUERY_PARAMS', queryParams);
  }
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};